import axios from 'axios'
import { useAuthHeader } from 'react-auth-kit'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
// import AddButton from '../../usables/small/AddButton'
import Table from '../../usables/Table'
import Input from '../../usables/small/Input'
import Modal from '../../usables/Modal'
import Spinner from '../../usables/small/Spinner'
import ClosingAlert from '../../usables/Alert'
import Select from 'react-select'

export default function  Users() {
  const auth  = useAuthHeader()
  const [formData, setFormData] = useState({name: '', firstname: '', lastname: '', email:'', password: '', role:0})
  const [users, setUsers] = useState([])
  const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})
  const [errorMsg, setErrorMsg] = useState('Nepavyko įrašyti reikšmės')
  const [showError, setShowError] = useState(false)

  const tableColumns = [{
    Header: "Vartotojai",
    columns: [
      {
        Header: "ID",
        accessor: "id"
      },
      {
        Header: "Prisijungimo vardas",
        accessor: "name"
      },
      {
        Header: "El. paštas",
        accessor: "email"
      },
      {
        Header: "Rolė",
        accessor: "role"
      },
      {
        Header: "Veiksmai",
        accessor: "action"
      }
    ]
  }]

  const config = {
    headers: {
      Authorization: auth()
    }
  }
  
  const createUser = () => {
    axios.post(process.env.REACT_APP_API + '/auth/register', formData, config)
      .then((res)=>{
        if(res.status === 200){
          res.data.user.action = <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/users/' + res.data.user.id}>Daugiau</Link>
          res.data.user.role = res.data.role.display_name
          setUsers(users => [res.data.user, ...users ])
          setFormData({name: '', firstname: '', lastname: '', email:'', password: '', role:0})
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError(true)
      })
    }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API + '/user', config)
    .then(res => {
      if(res.status === 200){
        //console.log(...res.data)
        setUsers([]) //! Pašalinti prieš buildinant
        res.data.forEach((data) => {
          data.action = <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/users/' + data.id}>Daugiau</Link>
          setUsers(users => [...users, data])
          setDataLoaded({done: true, sucssess: true, items: res.data.length})
        })
      }
    })    
    .catch(err => {
      setUsers([]) //! Pašalinti prieš buildinant
      //console.log(err.response.data)
      setUsers(users => [...users, err.response.data])
      setDataLoaded({done: true, sucssess: false, items: 0})
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  return (
    <>
    <h2>Vartotojai</h2>
    <ClosingAlert type='error' message={errorMsg} show={showError} updateState={(value) => {setShowError(value)}} />
      {!dataLoaded.done
      ? <Spinner />
      : dataLoaded.sucssess
        ?dataLoaded.items
          ? <Table columns={tableColumns} data={users} />
          : <ClosingAlert type='warning' message='Vartotojų nerasta' />
        : <ClosingAlert type='error' message='Kažkas nepavyko, bendykite vėl šiek tiek vėliau' />
      }
    {/* <Table columns={tableColumns} data={users} /> */}
    {/* <ul>
    Vartotojai: 
    {users.map(user => {
      return <li key={user.id}>{JSON.stringify(user)} <Link to={'/users/' + user.id}>Daugiau</Link></li>
    })}
    </ul> */}
    <Modal showAddBtn={true} title='Naujas vartotojas' saveText='Sukurti' submitFunction={() => createUser()}>
      <div className='pt-5'>
        <Input
          label='Prisijungimo vardas'
          name='username'
          type='text'
          value={formData.name}
          onChange={(e)=>setFormData({...formData, name: e.target.value})}
          />
        <Input
          label='Vardas'
          name='name'
          type='text'
          value={formData.firstname}
          onChange={(e)=>setFormData({...formData, firstname: e.target.value})}
          />
        <Input
          label='Pavardė'
          name='lastname'
          type='text'
          value={formData.lastname}
          onChange={(e)=>setFormData({...formData, lastname: e.target.value})}
          />
        <Input
          label='El. paštas'
          name='email'
          type='email'
          value={formData.email}
          onChange={(e)=>setFormData({...formData, email: e.target.value})}
          />
        <div className='pb-7'>
          <label className='text-gray-500' htmlFor="role">Rolė</label>
          <Select 
            name='role'
            onChange={(e)=>setFormData({...formData, role: e.value})} 
            options={
              [{key: 1, name: 'Administratorius'}, {key: 3, name: 'Mokytojas'}].map(role => {
                return ({ value: role.key, label: role.name })
              })
          } />
        </div>
        {/* <select
          value={formData.role}
          onChange={(e)=>setFormData({...formData, role: e.target.value})}
          className="form-select appearance-none
          block
          w-full
          pt-3 pb-2
          text-base
          font-normal
          text-gray-700
          bg-white bg-clip-padding bg-no-repeat
          border border-solid border-gray-300
          rounded
          transition
          ease-in-out
          m-0
          mb-6
          focus:text-gray-700 focus:bg-white focus:border-violet-700 focus:outline-none"
        >
            <option key={0} value={0} disabled>
              Rolė
            </option>
            <option key={1} value={1}>
              Administratorius
            </option>
            <option key={3} value={3}>
              Mokytojas
            </option>
        </select> */}
        <Input
          label='Slaptažodis'
          name='password'
          type='password'
          value={formData.password}
          onChange={(e)=>setFormData({...formData, password: e.target.value})}
          />
        </div>
      </Modal>
    {/* <AddButton /> */}
    </>
  )
}